// extracted by mini-css-extract-plugin
module.exports = {"Container":"ProjectsMap_Container__D_-Y9"};